import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'

import bugsnagClient from '@/lib/bugsnag'
import logger from '@/lib/logger'
import errorMessageHandler from '@/utils/errorMessageHandler'
import isNetworkError from '@/utils/isNetworkError'
import StoresContext from '@/utils/StoresContext'

interface Props {
  handler: (redirectResult: string) => Promise<void>
}

export default function useAdyenRedirectResult({ handler }: Props) {
  const router = useRouter()
  const { appStore } = useContext(StoresContext)

  useEffect(() => {
    const { redirectResult } = router.query
    if (!redirectResult) {
      return
    }

    ;(async () => {
      try {
        await handler(typeof redirectResult === 'string' ? redirectResult : redirectResult[0])

        const query = { ...appStore.state.query }
        ;['force-prepayment', 'token', 'redirectResult'].forEach((param) => {
          delete query[param]
        })

        router.push({
          pathname: '/thank_you',
          query
        })
      } catch (error) {
        appStore.state.error = errorMessageHandler(error)
        if (!isNetworkError(error)) {
          logger.error(error)
          bugsnagClient.notify(error)
        }
      }
    })()
  }, [appStore, handler, router, router.query.redirectResult])
}
